module.exports = __webpack_public_path__ + "static/media/lock.381b70cb.svg";